import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  .field {
    position: relative;
    width: 100%;
    padding: 5px;
    border: 0.5px solid #5e6366;
    border-radius: 3px;
    color: #aeaeae;

    span {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-transform: capitalize;
      &.filled {
        color: #5e5e5e;
      }
    }

    svg {
      position: absolute;
      right: 10px;
      bottom: 11px;
      color: #5e6366;
    }

    &:hover {
      &:hover {
        border: 0.5px solid #000 !important;
      }
      svg {
        color: #3c71dd;
      }
    }

    @media (max-width: 768px) {
      ${({ avoidMobileBehavior }) =>
        avoidMobileBehavior ? '' : 'display: none;'}
    }
  }
`;

/**
 * Estilização do componente StyledPaper
 */
export const StyledPaper = withStyles({
  root: {
    padding: '7px',
    overflow: 'auto',
    maxHeight: 'calc(100vh - 30px)',
  },
})(Paper);
